import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalFormat'
})
export class DecimalFormatPipe implements PipeTransform {

  transform(value: number, decimalPlaces?: number): string {
    if (isNaN(value)) {
      return '0';
    }
    if(!value){
      return '0';
    }
    if(!decimalPlaces)
      return value.toFixed(2);
    return value.toFixed(decimalPlaces)
  }

}
